export default __webpack_public_path__ + "static/media/team_syafiq.a4059b97.png";